// @ts-ignore
import * as Locale from '../locale/PT-BR.json'

const Messages = (type: String, error: String) => {
  let message: String = Locale.default._[error]
  const hasMessageType = Locale.default[type] && Locale.default[type][error]

  if (typeof hasMessageType !== "undefined") {
    message = Locale.default[type][error]
  }

  return message
}

export default Messages
